$(function () {
  console.log("Hello from search.js");

  var $searchBtn = $("#searchBtn");
  var $searchInput = $("#searchInput");
  var $searchContent = $(".searchContent");
  var $searchCardContainer = $(".searchCardContainer");

  $searchInput.on("keyup", function (event) {
    if (event.keyCode === 13) {
      event.preventDefault();
      var searchInput = $searchInput.val();
      if (searchInput.trim() !== "") {
        $searchBtn.addClass("is-loading");
        navigateToSearchPage(searchInput);
      }
    }
  });

  $searchBtn.on("click", function () {
    var searchInput = $searchInput.val();
    if (searchInput.trim() !== "") {
      $searchBtn.addClass("is-loading");
      navigateToSearchPage(searchInput);
    }
  });

  var searchCardContainerHeight = $searchCardContainer.height();
  $searchContent.height(searchCardContainerHeight);

  function navigateToSearchPage(searchInput) {
    window.location.href = `/search?s=${searchInput}`;
  }
});
